import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return;
}